import { useContext } from 'react'
import ConfirmContext from '../ConfirmContext'

const useConfirm = (component) => {
  const context = useContext(ConfirmContext)
  if (context === null) {
    const err = new Error(
      `<${component} /> is missing a parent <${component.replace(
        /([^.])+.*/,
        '$1'
      )} /> component.`
    )
    if (Error.captureStackTrace) Error.captureStackTrace(err, useConfirm)
    throw err
  }
  return context
}

export default useConfirm
